
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/declarations/[...slug]",
      function () {
        return require("private-next-pages/declarations/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/declarations/[...slug]"])
      });
    }
  